import { combineReducers } from 'redux';
import userReducer from './user.reducer';
import alertReducer from './alert.reducer';
import gameReducer from './game.reducer';
import playerReducer from './player.reducer';
import notificationReducer from './notification.reducer';
import { reducer as formReducer } from 'redux-form';

export default combineReducers({
    user: userReducer,
    alert: alertReducer,
    players: playerReducer,
    games: gameReducer,
    notifications: notificationReducer,
    form: formReducer
});


// WEBPACK FOOTER //
// ./src/reducers/index.js